import { ECheckDailyrentPriceActionTypes } from 'shared/actions/checkDailyrentPrice/types';
import { ResponseError } from 'shared/errors/responseError';
import { IV2CheckPriceResponse } from 'shared/repositories/dailyrent/entities/response/V2CheckPriceResponse';
import { TCheckPriceRequest } from 'shared/repositories/dailyrent/v2/check-price';
import { selectOfferId } from 'shared/selectors/offerData/offer/selectOfferId';
import { fetchCheckPrice } from 'shared/services/fetchCheckPrice';
import { DEFAULT_ERROR_MESSAGE } from 'shared/services/fetchGuestCalendar';
import { IThunkActionCreator } from 'shared/store';
import { trackMinimumDurationHint } from 'shared/tracking/dailyrentBookingCalendar';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

const setCheckDailyrentPriceLoading = actionGenerator<ECheckDailyrentPriceActionTypes.Loading, boolean>(
  ECheckDailyrentPriceActionTypes.Loading,
);
const setCheckDailyrentPriceSuccess = actionGenerator<ECheckDailyrentPriceActionTypes.Success, IV2CheckPriceResponse>(
  ECheckDailyrentPriceActionTypes.Success,
);
const setCheckDailyrentPriceFail = actionGenerator<ECheckDailyrentPriceActionTypes.Fail, string>(
  ECheckDailyrentPriceActionTypes.Fail,
);

const IS_BOOKED_ERROR_MESSAGE = 'Эти даты уже заняты';

export const checkDailyrentPrice =
  ({ dates, guestsCount }: Omit<TCheckPriceRequest, 'offerRealtyId'>): IThunkActionCreator<Promise<void | string>> =>
  async (dispatch, getState, context) => {
    const state = getState();
    const offerRealtyId = selectOfferId(state);
    dispatch(setCheckDailyrentPriceLoading(true));

    try {
      const response = await fetchCheckPrice(context, {
        offerRealtyId,
        dates,
        guestsCount,
      });

      dispatch(setCheckDailyrentPriceSuccess(response));
    } catch (error) {
      let errorMessage = DEFAULT_ERROR_MESSAGE;

      const isKnownError = ResponseError.is(error);
      const errorCode =
        isKnownError && error.details && 'code' in error.details && typeof error.details.code === 'string'
          ? error.details.code
          : '';

      if (errorCode === 'isBooked') {
        errorMessage = IS_BOOKED_ERROR_MESSAGE;
      } else if (['minStay', 'minStayArrival'].includes(errorCode)) {
        errorMessage = error.message;
      }

      if (errorCode === 'minStay') {
        trackMinimumDurationHint(offerRealtyId);
      }

      dispatch(setCheckDailyrentPriceFail(errorMessage));

      return errorMessage;
    } finally {
      dispatch(setCheckDailyrentPriceLoading(false));
    }

    return;
  };
